import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';

import { cn } from '~/lib/cn';

export const ModalDialogFooter = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      {...props}
      className={cn(
        'flex justify-end gap-lg border-t-px px-xl py-md bg-level-03 border-t-emphasis-subtle',
        props.className,
      )}
    >
      {children}
    </div>
  );
});

ModalDialogFooter.displayName = 'ModalDialog.Footer';
